import { LockeClientId, User, UserCookie } from './types';
import { isUserSignedIn } from './utils/signedInStatusService';
import { getUserInfoFromCookies } from './utils/cookieService';
import decodeJwt from 'jwt-decode';

export const getUser = async (
  lockeClientId: LockeClientId,
  onSessionExpired?: () => void,
): Promise<User> => {
  const { token, oldToken, rcauid, countryCode } = getUserInfoFromCookies();
  let isSignedIn = false;
  if (token || oldToken) {
    isSignedIn = await isUserSignedIn(token, oldToken, lockeClientId);
  }
  if (!isSignedIn && onSessionExpired) {
    onSessionExpired();
  }

  return {
    rcauid,
    countryCode,
    isSignedIn,
  };
};

const isClientSide = (): boolean => typeof window !== 'undefined';

export const decodeUserCookie = (cookie: string): UserCookie | undefined => {
  try {
    const jsonString = isClientSide()
      ? window.atob(cookie)
      : Buffer.from(cookie, 'base64').toString('utf-8');
    const { uid, lid, expiry } = JSON.parse(jsonString) as {
      uid: string;
      lid: string;
      expiry: number;
    };
    return {
      myRcaId: uid,
      lockeId: lid,
      expiry,
    };
  } catch (error) {
    console.log('Error identifying user: ', error);
    return undefined;
  }
};

export const decodeLmdstok = (lmdstok: string): UserCookie | undefined => {
  try {
    const { exp, locke_id, uid } = decodeJwt<{
      exp: number;
      locke_id: string;
      uid: string;
    }>(lmdstok);
    return {
      expiry: exp,
      lockeId: locke_id,
      myRcaId: uid,
    };
  } catch (error) {
    console.log('Error identifying old user: ', error);
    return undefined;
  }
};

export const getUserCookie = (): UserCookie | undefined => {
  const { token, oldToken } = getUserInfoFromCookies();

  if (token) {
    const userCookie = decodeUserCookie(token);
    if (userCookie) {
      return userCookie;
    }
  } else if (oldToken) {
    const userCookie = decodeLmdstok(oldToken);
    if (userCookie) {
      return userCookie;
    }
  } else {
    return undefined;
  }
};
